export function SET_FILTERS(
	{ commit },
	[search, selected_areas, selected_categories, selected_tags, selected_extensions]
) {
	commit('SAVE_FILTERS', [
		search,
		selected_areas,
		selected_categories,
		selected_tags,
		selected_extensions,
	])
}

export function SET_FILTERS_SEARCH({ commit }, [search]) {
	commit('SAVE_FILTERS_SEARCH', [search])
}

export function SET_FILTERS_CATEGORY({ commit }, [selected_categories]) {
	commit('SAVE_FILTERS_CATEGORY', [selected_categories])
}

export function SET_FILTERS_TAG({ commit }, [selected_tags]) {
	commit('SAVE_FILTERS_TAG', [selected_tags])
}

export function SET_LOADING({ commit }, [loading]) {
	commit('SAVE_LOADING', [loading])
}
